import { CSSProperties } from 'react';

import { styled } from '../../../theme';
import FlexColumn from '../../FlexColumn';
import FlexRow from '../../FlexRow';
import SvgIcon from '../../SvgIcon';

const OPTION_MIN_HEIGHT = 48;

export const Body = styled(FlexColumn)({
    gap: 12,
    alignItems: 'flex-start',
    width: '100%',
});

export const OptionList = styled(FlexColumn)(({ theme }) => ({
    width: '100%',
    border: `1px solid ${theme.color.gray15}`,
    borderRadius: theme.borderRadius.base,
    overflow: 'hidden',
}));

export const OptionRow = styled.div(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    width: '100%',
    minHeight: OPTION_MIN_HEIGHT,
    padding: '10px 16px',
    boxSizing: 'border-box',
    border: 'none',
    borderTop: `1px solid ${theme.color.gray15}`,
    background: theme.color.white,
    color: theme.color.jetBlack,
    fontFamily: theme.typography.fontFamily,
    fontSize: 16,
    lineHeight: '24px',
    textAlign: 'left',
    '&:first-of-type': {
        borderTop: 'none',
    },
}));

export const OptionButton = styled(OptionRow.withComponent('button'))(({ theme }) => ({
    padding: '10px 12px 10px 16px',
    cursor: 'pointer',
    ':hover:not(:disabled)': {
        background: theme.color.backgroundGray,
    },
    ':focus-visible': {
        outline: `2px solid ${theme.color.green1}`,
        outlineOffset: -2,
    },
    ':disabled': {
        cursor: 'default',
        color: theme.color.gray40,
    },
}));

export const Chevron = styled(SvgIcon)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 20,
    height: 20,
    color: theme.color.gray70,
    cursor: 'inherit',
    transform: 'scaleX(-1)',
}));

export const SelectedRow = styled(FlexRow)(({ theme }) => ({
    alignItems: 'center',
    gap: 8,
    minHeight: OPTION_MIN_HEIGHT,
    padding: '10px 16px',
    boxSizing: 'border-box',
    background: theme.color.surface2,
    color: theme.color.jetBlack,
    fontSize: 16,
    lineHeight: '24px',
}));

export const SelectedState = styled(FlexRow)(({ theme }) => ({
    alignItems: 'center',
    gap: 8,
    flexShrink: 0,
    color: theme.color.gray70,
    fontSize: 14,
    lineHeight: '20px',
}));

export const optionNameWrapperStyles: CSSProperties = {
    flex: 1,
    minWidth: 0,
};
